export default __webpack_public_path__ + "static/media/c2.2fe0e073.png";